document.addEventListener("DOMContentLoaded", function () {
  var carousels = document.querySelectorAll("announcement-bar-carousel");

  carousels.forEach(function (carousel) {
    var slides = carousel.querySelectorAll(".prose.heading");
    var section = carousel.closest("[id^='shopify-section-']");
    if (!section) return;

    var prevButton = section.querySelector("carousel-prev-button button");
    var nextButton = section.querySelector("carousel-next-button button");
    var cycleSpeed = parseInt(carousel.getAttribute("autoplay")) * 1000;
    var index = 0;
    var autoRotate;

    function rotateCarousel(next) {
      next = next !== false;
      slides[index].style.opacity = "0";
      slides[index].style.transform = "translateY(-10px)";

      setTimeout(function () {
        slides[index].classList.remove("is-selected");
        index = next ? (index + 1) % slides.length : (index - 1 + slides.length) % slides.length;
        slides[index].classList.add("is-selected");
        slides[index].style.opacity = "1";
        slides[index].style.transform = "translateY(0)";
      }, 500);

      restartAutoRotate();
    }

    function restartAutoRotate() {
      clearInterval(autoRotate);
      if (carousel.hasAttribute("autoplay")) {
        autoRotate = setInterval(rotateCarousel, cycleSpeed);
      }
    }

    if (slides.length > 1) {
      restartAutoRotate();

      if (prevButton) {
        prevButton.addEventListener("click", function () {
          rotateCarousel(false);
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", function () {
          rotateCarousel(true);
        });
      }
    }
  });
});